/**
 * HELP-GUIDE.CONTEXT
 * Guide of the current page (written in Strapi) : the link of the header and the hints of the zones open the same window
 */
import { createContext } from "react"
import { HelpArticle } from "@/utils/help-article.utils"

export interface HelpGuideContextValue {
  article: HelpArticle | null | undefined //undefined while loading, null if there is no guide for the page
  isAvailable: boolean //The guide is published, meant for the role and the application is in French
  open: (section?: string) => void //Open the guide, on a section if there is one
  isGollac: boolean //Display of the survey (the values of the account depend on it)
}

export const HelpGuideContext = createContext<HelpGuideContextValue>({
  article: null,
  isAvailable: false,
  open: () => {},
  isGollac: false
})
